export default __webpack_public_path__ + "static/media/Serena.c8733873.jpg";